// Confirm Template to Use
export const ConfirmTemplateToUse = "ConfirmTemplateToUse";

// Subjective Assessment 1
export const ClientsExpectations = "ClientsExpectations";
export const MainProblemOrProgressUpdate = "MainProblemOrProgressUpdate";
export const AdherenceToHomeExerciseAndAdvicePlan = "AdherenceToHomeExerciseAndAdvicePlan";
export const OnsetDate = "OnsetDate";
export const FirstEpisodeOfPain = "FirstEpisodeOfPain";
export const ChronicProblem = "ChronicProblem";
export const HistoryOfPresentComplaint = "HistoryOfPresentComplaint";
export const Injured = "Injured";
export const PainNRSAverage = "PainNRSAverage";
export const PainNRSWorse = "PainNRSWorse";
export const PainNRSBest = "PainNRSBest";
export const TwentyFourHourPattern = "TwentyFourHourPattern";
export const AggravatingEasingFactors = "AggravatingEasingFactors";
export const Investigations = "Investigations";
export const PreviousTreatment = "PreviousTreatment";
export const DidThePreviousTreatmentHelp = "DidThePreviousTreatmentHelp";
export const DetailsOfPreviousTreatment = "DetailsOfPreviousTreatment";
// Subjective Assessment 2: CSSQ === Complete Cervical Spine Special Question
export const CompleteCSSQs = "CompleteCSSQs";
export const CSSQConstantHeadache = "CCSSQConstantHeadache";
export const CSSQNausea = "CSSQNausea";
export const CSSQSensoryChanges = "CSSQSensoryChanges";
export const CSSQDropAttacks = "CSSQDropAttacks";
export const CSSQDizziness = "CSSQDizziness";
export const CSSQSwallowingDifficulties = "CSSQSwallowingDifficulties";
export const CSSQSpeechDifficulties = "CSSQSpeechDifficulties";
export const CSSQVisionDifficulties = "CSSQVisionDifficulties";
export const CSSQAlteredGait = "CSSQAlteredGait";
export const CSSQConstantNightPain = "CSSQConstantNightPain";
export const CSSQUnexplainedWeightLoss = "CSSQUnexplainedWeightLoss";
export const CSSQPreviousHistoryOfCancer = "CSSQPreviousHistoryOfCancer";
// Subjective Assessment 3: LSSQ === Lumbar Spine Special Question
export const CompleteLSSQs = "CompleteLSSQs";
export const LSSQBowelOrBladderSymptoms = "LSSQBowelOrBladderSymptoms";
export const LSSQSaddleAnaesthesia = "LSSQSaddleAnaesthesia";
export const LSSQBilateralLegPainPinsAndNeedles = "LSSQBilateralLegPainPinsAndNeedles";
export const LSSQAlteredGait = "LSSQAlteredGait";
export const LSSQConstantNightPain = "LSSQConstantNightPain";
export const LSSQUnexplainedWeightLoss = "LSSQUnexplainedWeightLoss";
export const LSSQPreviousHistoryOfCancer = "LSSQPreviousHistoryOfCancer";
// Subjective Assessment 4: PJSQ === Peripheral Joint Special Question
export const CompletePJSQs = "CompletePJSQs";
export const PJSQSevereSwelling = "PJSQSevereSwelling";
export const PJSQPoppingClicking = "PJSQPoppingClicking";
export const PJSQGivingWayInstability = "PJSQGivingWayInstability";
export const PJSQLockingCatching = "PJSQLockingCatching";
// Subjective Assessment 5
export const PastMedicalHistory = "PastMedicalHistory";
export const Medication = "Medication";
export const FamilyHistory = "FamilyHistory";
export const SmokingStatus = "SmokingStatus";
export const CommentsOnSmokingStatus = "CommentsOnSmokingStatus";
export const AlcoholConsumptionInUnitsPerWeek = "AlcoholConsumptionInUnitsPerWeek";
export const SocialHistoryHobbiesPhysicalActivity = "SocialHistoryHobbiesPhysicalActivity";
export const WorkDemands = "WorkDemands";
export const NumberOfDaysOffWorkDueToThisConditionInTheLast12Months = "NumberOfDaysOffWorkDueToThisConditionInTheLast12Months";
export const CurrentWorkStatus = "CurrentWorkStatus";
export const ExpectedReturnToWorkDate = "ExpectedReturnToWorkDate";
export const MedicalClassification = "MedicalClassification";
export const SubCategory = "SubCategory";

// Objective Assessment
export const ObjectiveAssessmentFindings = "ObjectiveAssessmentFindings";

// Assessment Summary 1
export const ClinicalImpression = "ClinicalImpression";
// Assessment Summary 2: Psycho-social factors (HEADER)
export const PainMeansHarm = "PainMeansHarm";
export const FearAvoidance = "FearAvoidance";
export const PassiveAttitude = "PassiveAttitude";
export const Catastrophising = "Catastrophising";
export const WorkIsResponsible = "WorkIsResponsible";
export const MentalHealthIssues = "MentalHealthIssues";
// Assessment Summary 3
export const PsychoSocialFactorsBarriersToWork = "PsychoSocialFactorsBarriersToWork";

// Management & Outcome
export const ManagementPlanAndTreatment = "ManagementPlanAndTreatment";
export const WorkRecommendationsAndReturnToWorkPlan = "WorkRecommendationsAndReturnToWorkPlan";
export const SelfManagementAdviceAndExercisePlanProvided = "SelfManagementAdviceAndExercisePlanProvided";
export const Outcome = "Outcome";

// Consent to release report
export const ScopeOfReport = "ScopeOfReport";
export const AlternativeConsentChoice = "AlternativeConsentChoice";
export const EmployeeEmailAddress = "EmployeeEmailAddress";
export const ManagerEmailAddress = "ManagerEmailAddress";
export const HREmailAddress = "HREmailAddress";
